module.exports = {
  RichText: {
    background_color: "Background color",
    border_color: "Border color",
    border_size: "Border Size",
    border_style: "Border Style",
    box_style: "Box style",
    opacity: "Opacity",
    padding: "Padding",
    PluginName: "Rich Text",
    radius: "Radius",
    source: "Source",
  },
};
